const instances = new Map();

function mount(root) {
  if (instances.has(root)) return;
  const controls = root.querySelector('[data-product-controls]');
  const product = root.closest('product-info');
  const form = product?.querySelector('form[data-product-form]');
  const configNode = root.querySelector('[data-native-variants]');
  if (!controls || !form || !configNode) return;
  const variants = JSON.parse(configNode.textContent);
  const abort = new AbortController();
  root.querySelectorAll('[data-gallery-direction]').forEach(arrow => {
    arrow.addEventListener('click', () => {
      const thumbnails = [...root.querySelectorAll('.onn-gallery__thumb')];
      const current = Math.max(0, thumbnails.findIndex(item => item.getAttribute('aria-pressed') === 'true'));
      const next = thumbnails[(current + Number(arrow.dataset.galleryDirection) + thumbnails.length) % thumbnails.length];
      next?.click();
      const strip = root.querySelector('.onn-gallery__thumbs');
      if (strip && next) strip.scrollTo({left:next.offsetLeft - thumbnails[0].offsetLeft,behavior:'smooth'});
    }, {signal:abort.signal});
  });
  const name = controls.querySelector('[data-product-name]');
  const error = controls.querySelector('[data-product-error]');
  let busy = false;
  let selected;
  const requiredChoices = ['font', 'chain', 'length', 'thickness'];
  const buttons = Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"], [data-add-to-cart]'));
  controls.querySelectorAll('[data-choice], [data-product-name]').forEach(input => { input.required = true; if (form.id) input.setAttribute('form', form.id); });
  const checked = key => controls.querySelector(`[data-choice="${key}"]:checked`);
  const money = cents => new Intl.NumberFormat('en-GB', {style:'currency', currency:root.dataset.currency || 'GBP'}).format(cents / 100);
  function readPromo() {
    if (root.dataset.priceLocked === 'true' || root.dataset.promoEnabled !== 'true') return null;
    if (root.dataset.promoSource === 'manual') {
      const percentage = Number(root.dataset.promoPercent);
      const code = (root.dataset.promoCode || '').trim();
      return code && Number.isFinite(percentage) && percentage > 0 && percentage <= 100 ? {percentage, code} : null;
    }
    const displayed = element => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && getComputedStyle(element).visibility !== 'hidden';
    };
    // Ignore saved, hidden banners; only use the offer currently displayed.
    const copy = Array.from(document.querySelectorAll('.orli-offer-copy')).find(displayed);
    const sticky = document.querySelector('.orli-sticky-usps__promo');
    const container = copy?.parentElement || (sticky && displayed(sticky) ? sticky : null);
    if (!container) return null;
    const text = (copy || container).textContent.replace(/\s+/g, ' ').trim();
    if (/up\s+to|selected|buy\s+\d|when\s+(?:you\s+)?spend|orders?\s+(?:over|above)|over\s*[£€$]|extra/i.test(text)) return null;
    const percent = text.match(/(?:^|\s)(\d{1,2}(?:\.\d+)?|100)\s*%\s*(?:off|discount)/i);
    const codeButton = container.querySelector('.orli-offer-code');
    const codeText = codeButton?.querySelector('.orli-offer-code-label')?.textContent || container.textContent;
    const codeMatch = codeText.match(/(?:use\s+)?code\s*[:–-]?\s*([A-Za-z0-9_-]+)/i);
    const code = codeButton?.dataset.copyCode?.trim() || codeMatch?.[1];
    const percentage = Number(percent?.[1]);
    return percentage > 0 && percentage <= 100 && code ? {percentage, code} : null;
  }
  function updateOfferPrice() {
    if (!selected) return;
    const promo = readPromo();
    const locked = root.dataset.priceLocked === 'true';
    const compareAt = Number(selected.compareAtPrice || 0);
    const offerPrice = promo ? Math.round(selected.price * (100 - promo.percentage) / 100) : selected.price;
    controls.querySelector('[data-product-total]').textContent = money(offerPrice);
    const regularPrice = controls.querySelector('[data-product-regular]');
    regularPrice.textContent = money(locked ? compareAt : selected.price);
    regularPrice.hidden = locked ? compareAt <= selected.price : !promo;
    if (lockedDisplay) {
      lockedDisplay.querySelector('[data-name-locked-compare]').textContent = money(compareAt);
      lockedDisplay.querySelector('[data-name-locked-current]').textContent = money(selected.price);
    }
    controls.querySelector('[data-product-promo]').hidden = !promo;
    controls.querySelector('[data-product-promo-code]').textContent = promo?.code || '';
    const badge = controls.querySelector('[data-product-promo-badge]');
    badge.textContent = locked ? '20% off · price locked' : promo ? `${promo.percentage}% off` : '';
    badge.hidden = !locked && !promo;
    controls.querySelector('[data-product-before-discount]').hidden = !promo;
  }
  const proxy = (prefix, value) => {
    const target = root.querySelector(`input[name^="${prefix}"][value="${value}"]`);
    if (target) target.checked = true;
  };
  const priceWrap = product.querySelector('.product__price__wrap');
  const priceBlock = priceWrap?.closest('.product__block');
  let lockedDisplay;
  if (root.dataset.priceLocked === 'true' && priceBlock) {
    priceWrap.classList.add('onn-legacy-price-hidden');
    lockedDisplay = document.createElement('div');
    lockedDisplay.className = 'onn-locked-price';
    lockedDisplay.setAttribute('aria-live', 'polite');
    lockedDisplay.innerHTML = '<span class="visually-hidden">Original price</span><s data-name-locked-compare></s><span class="visually-hidden">Price with 20% off</span><strong data-name-locked-current></strong><span class="onn-top-discount-badge">20% off</span>';
    priceBlock.append(lockedDisplay);
  }
  if (priceBlock) priceBlock.after(controls);
  else form.before(controls);
  const information = document.createElement('div');
  information.className = 'onn-product-information';
  const details = product.querySelector('.orli-fit');
  const lengthGuide = product.querySelector('orli-necklace-guide');
  if (details) information.append(details);
  const chainLengthField = controls.querySelector('[data-choice="length"]')?.closest('fieldset');
  if (lengthGuide && chainLengthField) chainLengthField.append(lengthGuide);
  const sku = product.querySelector('.product__sku');
  const skuParent = sku?.parentElement;
  const skuNext = sku?.nextSibling;
  const finerDetails = product.querySelector('[id$="-accordion_wKMYUg"] .orli-details-content');
  if (sku && finerDetails) finerDetails.append(sku);
  if (finerDetails) finerDetails.closest('details').open = false;
  if (information.children.length) controls.before(information);
  product.classList.add('onn-product-native-active');
  const matches = product.querySelector('.orli-gallery-look');
  const matchesParent = matches?.parentElement;
  // Keep the recommendations below the two-column section so sticky media
  // cannot overlap them as the customer reaches the bottom of the options.
  if (matches) product.querySelector('.product__wrapper')?.after(matches);
  const floating = document.createElement('aside');
  floating.className = 'onn-floating-preview';
  floating.hidden = true;
  floating.setAttribute('aria-label', 'Your live necklace preview');
  floating.innerHTML = '<button type="button" class="onn-floating-preview__toggle" aria-label="Back to full necklace preview"><span>YOUR LIVE PREVIEW</span><span class="onn-floating-preview__action">Full preview ↑</span></button><canvas data-floating-mini width="480" height="160" aria-label="Your personalised necklace"></canvas>';
  document.body.append(floating);
  const floatingButton = floating.querySelector('button');
  floatingButton.addEventListener('click', () => {
    controls.querySelector('[data-gallery-jump]')?.click();
  }, {signal: abort.signal});
  const floatingCanvas = floating.querySelector('canvas');
  // A 2D copy of the existing frame keeps the mobile preview lightweight.
  root.addEventListener('onn:preview-frame', event => {
    const source = event.detail.canvas;
    floatingCanvas.getContext('2d').drawImage(source, 0, 0, floatingCanvas.width, floatingCanvas.height);
  }, {signal: abort.signal});
  let scrollFrame = 0;
  function updatePreviewPosition() {
    scrollFrame = 0;
    const header = document.querySelector('header.theme__header');
    const benefits = document.querySelector('orli-sticky-usps');
    const headerRect = header?.getBoundingClientRect();
    const benefitsRect = benefits?.getBoundingClientRect();
    const offer = Array.from(document.querySelectorAll('.orli-offer-copy')).find(e => e.getBoundingClientRect().height > 0)?.closest('[data-hidden]');
    const headerBottom = Math.max(0, header && getComputedStyle(header).visibility !== 'hidden' ? headerRect.bottom : 0, benefitsRect?.bottom || 0, offer?.getBoundingClientRect().bottom || 0);
    const offset = Math.ceil(headerBottom) + 8;
    if (product.style.getPropertyValue('--onn-sticky-top') !== `${offset}px`) product.style.setProperty('--onn-sticky-top', `${offset}px`);
    floating.style.top = `${offset}px`;
    const stage = root.querySelector('[data-stage]').getBoundingClientRect();
    const boundary = controls.getBoundingClientRect();
    floating.hidden = !window.matchMedia('(max-width: 749px)').matches || stage.bottom > offset || boundary.bottom < offset + 180;
  }
  const schedulePosition = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updatePreviewPosition); };
  window.addEventListener('scroll', schedulePosition, {passive:true, signal:abort.signal});
  window.addEventListener('resize', schedulePosition, {passive:true, signal:abort.signal});
  updatePreviewPosition();
  const drawer = controls.querySelector('[data-personalise-drawer]');
  drawer?.addEventListener('toggle', () => { updateReadiness(); schedulePosition(); }, {signal:abort.signal});
  function updateReadiness() {
    const missing = [];
    if (!/^[A-Za-z]{1,12}$/.test(name.value)) missing.push('enter your name');
    if (!checked('font')) missing.push('choose a font');
    if (!checked('length')) missing.push('choose a chain length');
    const ready = !missing.length && requiredChoices.every(key => checked(key)) && Boolean(selected);
    buttons.forEach(button => { button.disabled = busy || !ready; button.setAttribute('aria-disabled', String(busy || !ready)); });
    if (drawer) {
      controls.querySelector('[data-drawer-title]').textContent = ready ? 'Edit your personalisation' : 'Personalise your necklace';
      controls.querySelector('[data-drawer-hint]').textContent = ready ? [name.value, checked('font')?.value === 'signature' ? 'Signature' : 'Classic', checked('chain')?.value, checked('length')?.value].filter(Boolean).join(' · ') : 'Start here — add your name and choose your style';
    }
    controls.querySelector('[data-required-status]').textContent = missing.length && drawer && !drawer.open ? 'Open personalisation above to add your name and choose your chain length.' : missing.length ? `${new Intl.ListFormat('en-GB', {style:'long', type:'conjunction'}).format(missing).replace(/^./, c => c.toUpperCase())} to add your necklace to the basket.` : '';
  }
  function syncName() {
    const value = name.value.replace(/[^A-Za-z]/g, '').slice(0, 12);
    name.value = value;
    root.querySelector('[data-name]').value = value;
    root.querySelector('[data-name]').dispatchEvent(new Event('input', {bubbles:true}));
    controls.querySelector('[data-product-count]').textContent = `${value.length} / 12`;
    error.textContent = '';
    name.classList.remove('is-invalid');
    name.removeAttribute('aria-invalid');
    updateReadiness();
  }
  function sync() {
    const font = checked('font')?.value || root.querySelector('input[name^="onn-font-"]:checked')?.value || 'signature';
    const chain = checked('chain').value;
    const thickness = checked('thickness').value;
    const length = checked('length')?.value;
    const extender = controls.querySelector('[data-product-extender]').checked;
    const finish = `${thickness === 'premium' ? 'Premium 1 mm' : 'Classic 0.7 mm'}${extender ? ' + 5 cm extender' : ''}`;
    selected = variants.find(v => v.options[0].toLowerCase() === font && v.options[1] === chain && v.options[2] === finish);
    proxy('onn-font-', font);
    proxy('onn-chain-', `${chain} Chain`);
    if (length) proxy('onn-length-', length);
    proxy('onn-thickness-', thickness === 'premium' ? 'Premium · 1 mm' : 'Classic · 0.7 mm');
    root.querySelector('[data-extender]').checked = extender;
    if (!selected) { error.textContent = 'This combination is unavailable. Please choose another option.'; updateReadiness(); return; }
    root.dataset.nativePrice = String(selected.price / 100);
    const id = form.querySelector('[name="id"]');
    if (id) { id.value = String(selected.id); id.disabled = false; }
    root.querySelector('[data-extender]').dispatchEvent(new Event('change', {bubbles:true}));
    updateOfferPrice();
    product.querySelectorAll('[data-product-price-compare]').forEach(el => el.textContent = money(selected.compareAtPrice || selected.price));
    product.querySelectorAll('[data-product-price], .price__regular .price-item--regular').forEach(el => el.textContent = money(selected.price));
    const points = Math.floor(selected.price / 100 * Number(root.dataset.pointsRate));
    controls.querySelector('[data-native-points]').textContent = `${points.toLocaleString('en-GB')} points`;
    controls.querySelector('[data-native-reward-value]').textContent = money(points);
    controls.querySelector('[data-native-installment]').textContent = money(Math.floor(selected.price / 3));
    const remaining = selected.price - Math.floor(selected.price / 3) * 2;
    controls.querySelector('[data-installment-note]').textContent = remaining === Math.floor(selected.price / 3) ? '' : `Final payment ${money(remaining)}.`;
    updateReadiness();
  }
  async function submit(event) {
    if (event.type === 'click' && !event.target.closest('button[type="submit"], input[type="submit"], [data-add-to-cart]')) return;
    if (event.type === 'click' && event.target.closest('button, input')?.form !== form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    if (!/^[A-Za-z]{1,12}$/.test(name.value)) {
      error.textContent = 'Please enter a name using 1–12 letters.';
      name.classList.add('is-invalid');
      name.setAttribute('aria-invalid', 'true');
      name.focus();
      return;
    }
    const missingChoice = requiredChoices.find(key => !checked(key));
    if (missingChoice) {
      error.textContent = `Please choose ${missingChoice === 'length' ? 'a chain length' : missingChoice === 'font' ? 'a font' : missingChoice === 'chain' ? 'a chain style' : 'a name thickness'}.`;
      controls.querySelector(`[data-choice="${missingChoice}"]`).focus();
      return;
    }
    if (!selected) { error.textContent = 'Please choose an available combination.'; return; }
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    if (!Number.isSafeInteger(quantity) || quantity < 1) { error.textContent = 'Please choose a valid quantity.'; return; }
    const variant = selected;
    busy = true;
    error.textContent = '';
    buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    const properties = {
      'Your Name': name.value,
      'Font': checked('font').value === 'classic' ? 'Classic' : 'Signature',
      'Chain Style': `${checked('chain').value} Chain`,
      'Chain Length': checked('length').value,
      'Name Thickness': checked('thickness').value === 'premium' ? 'Premium (1 mm)' : 'Classic (0.7 mm)',
      '5 cm extender': controls.querySelector('[data-product-extender]').checked ? 'Yes' : 'No'
    };
    const inputs = Array.from(controls.querySelectorAll('input'));
    const disabledStates = inputs.map(input => input.disabled);
    inputs.forEach(input => input.disabled = true);
    try {
      const preview = await new Promise(resolve => {
        const timer = setTimeout(() => resolve(''), 800);
        root.dispatchEvent(new CustomEvent('onn:capture-preview', {detail:{resolve(image) {clearTimeout(timer);resolve(image);}}}));
      });
      if (preview) {
        try {
          const key = `${variant.id}|${properties['Your Name']}|${properties['Chain Length']}`;
          const stored = JSON.parse(sessionStorage.getItem('orli:name-necklace-previews') || '{}');
          delete stored[key];
          stored[key] = preview;
          const entries = Object.entries(stored).slice(-20);
          sessionStorage.setItem('orli:name-necklace-previews', JSON.stringify(Object.fromEntries(entries)));
        } catch (_) { /* Basket keeps its normal product photo if storage is unavailable. */ }
      }
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({items:[{id:variant.id, quantity, properties}]}), signal:abort.signal
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(response.status === 422 ? 'This necklace is not available to order yet. Please contact us if you need help.' : 'Your necklace could not be added. Please try again.');
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles:true}));
      const button = buttons[0];
      button?.dispatchEvent(new CustomEvent('theme:product:add', {bubbles:true, detail:{response:result, button}}));
      controls.querySelector('[data-cart-status]').textContent = 'Your personalised necklace has been added to your basket.';
      if (window.theme?.settings?.cartType === 'page') window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (failure) {
      if (failure.name !== 'AbortError') error.textContent = failure.message || 'Please check your connection and try again.';
    } finally {
      inputs.forEach((input, index) => input.disabled = disabledStates[index]);
      busy = false;
      buttons.forEach(b => b.removeAttribute('aria-busy'));
      updateReadiness();
    }
  }
  name.addEventListener('input', syncName, {signal:abort.signal});
  controls.addEventListener('change', sync, {signal:abort.signal});
  form.addEventListener('submit', submit, {capture:true, signal:abort.signal});
  product.addEventListener('click', submit, {capture:true, signal:abort.signal});
  syncName();
  sync();
  const promoObserver = new MutationObserver(updateOfferPrice);
  const promoRoots = new Set(Array.from(document.querySelectorAll('.orli-offer-copy')).map(copy => copy.closest('.shopify-section') || copy.parentElement));
  const stickyPromo = document.querySelector('.orli-sticky-usps__promo');
  if (stickyPromo) promoRoots.add(stickyPromo);
  promoRoots.forEach(element => promoObserver.observe(element, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['hidden','style','class']}));
  window.addEventListener('resize', updateOfferPrice, {passive:true, signal:abort.signal});
  document.addEventListener('shopify:section:load', updateOfferPrice, {signal:abort.signal});
  instances.set(root, () => {
    promoObserver.disconnect();
    abort.abort();
    cancelAnimationFrame(scrollFrame);
    floating.remove();
    lockedDisplay?.remove();
    priceWrap?.classList.remove('onn-legacy-price-hidden');
    if (matches && matchesParent?.isConnected) matchesParent.append(matches);
    product.style.removeProperty('--onn-sticky-top');
    product.classList.remove('onn-product-native-active');
    if (priceBlock) { if (details) priceBlock.append(details); if (lengthGuide) priceBlock.append(lengthGuide); }
    if (sku && skuParent?.isConnected) skuParent.insertBefore(sku, skuNext?.parentNode === skuParent ? skuNext : null);
    information.remove();
    root.append(controls);
  });
}
function initialise() {
  for (const [root, cleanup] of instances) if (!root.isConnected) { cleanup(); instances.delete(root); }
  document.querySelectorAll('.onn--product').forEach(mount);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
else initialise();
document.addEventListener('shopify:section:load', initialise);
document.addEventListener('shopify:section:unload', event => {
  for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
});
